import { cx } from 'cvb';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import { noop } from '../../../utils/noop';
import { BackgroundOverlayStyles } from './BackgroundOverlay.style';

const BackgroundOverlay = ({ shade }) => {
  const overlayRef = useRef();

  return createPortal(
    <div
      ref={overlayRef}
      onKeyDown={noop}
      tabIndex="0"
      role="button"
      className={cx(`background-overlay`, shade && typeof shade === 'string' && `shade-${shade}`)}
    >
      <style jsx>{BackgroundOverlayStyles}</style>
    </div>,
    document.body
  );
};

BackgroundOverlay.defaultProps = {
  shade: null,
};

BackgroundOverlay.propTypes = {
  shade: PropTypes.oneOf(['lighter']),
};

export default BackgroundOverlay;
